/**
 * Hero - About Us — Swiper init for the right-column image slider.
 * Loads via {{ 'section-hero-about.js' | asset_url }} with defer, after swiper-bundle.min.js.
 *
 * Resilient to:
 *  - Swiper not yet loaded (polls up to 6s)
 *  - Multiple section instances on a page
 *  - Theme-editor live reload (shopify:section:load)
 */
(function () {
  'use strict';

  var SELECTOR = '.about-hero-swiper';
  var MAX_RETRIES = 30;
  var RETRY_DELAY_MS = 200;

  function initOne(el) {
    if (el.dataset.swiperReady === '1') return;
    var slidesCount = el.querySelectorAll('.swiper-slide').length;
    if (!slidesCount) return;
    el.dataset.swiperReady = '1';
    var delay = parseInt(el.dataset.autoplayDelay, 10);
    if (!delay || isNaN(delay)) delay = 5000;
    // eslint-disable-next-line no-new
    new Swiper(el, {
      loop: slidesCount > 1,
      speed: 600,
      autoplay: {
        delay: delay,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      pagination: {
        el: el.querySelector('.about-hero-swiper__pagination'),
        clickable: true,
      },
    });
  }

  function boot(scope, attempt) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var els = root.querySelectorAll(SELECTOR);
    if (!els.length) return;

    if (typeof Swiper === 'undefined') {
      if ((attempt || 0) < MAX_RETRIES) {
        setTimeout(function () { boot(scope, (attempt || 0) + 1); }, RETRY_DELAY_MS);
      }
      return;
    }

    els.forEach(initOne);
  }

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    boot();
  } else {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  }
  // Safety net — fires after every image/iframe has loaded
  window.addEventListener('load', function () { boot(); });

  // Theme editor live-reload support
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  }
})();
